export const SLIDER_LABEL = 'Carousel of images';
export const SLIDER_PREVIOUS_BUTTON_LABEL = 'Previous image';
export const SLIDER_NEXT_BUTTON_LABEL = 'Next image';
export const IMG_ALT_PREFIX = 'Photo ';
export const DIVIDER = ' out of ';
export const SLIDES_PER_VIEW = 1;
export const IMAGES_SPACING = 30;
export const IMAGE_CLASSNAME = 'image-slider-img';
